<template>
<div class="discussion_cell container-fluid">
  <div class="row">
    <div class="col-xs-2" style="width: 70px;">
      <img src="" style="width: 100%;"/>
    </div>
    <div class="col-xs-10" style="width: calc( 100% - 70px );">
      <div>{{comment.user.name}}<span class="comment_datetime">({{comment.created_datetime}})</span></div>
      <p style="margin-bottom: 0;">{{comment.message}}</p>
      <a style="display: block;" @click="isShowReplyTextDiv = true">回覆</a>
      <div v-show="isShowReplyTextDiv" class="reply_textarea_div">
        <div class="mdl-textfield mdl-js-textfield" style="width: 100%;">
          <md-field>
            <md-textarea type="text" class="mdl-textfield__input reply_textarea" v-model="replyMessage" placeholder="Reply here..."></md-textarea>
          </md-field>
        </div>
        <div class="row">
          <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent reply_post_btn" style="float: right; margin-left: 10px;" :disabled="replyMessage.length === 0" @click="post_reply">發佈</button>
          <button class="mdl-button mdl-js-button mdl-button--raised" style="float: right;" @click="cancel_reply">取消</button>
        </div>
      </div>
      <div v-if="replies.length > 0">
        <a style="display: block;" @click="isShowReply = !isShowReply">{{isShowReply?'收起 ^':'顯示更多 v'}}</a>
        <div v-show="isShowReply" class="reply_list">
          <ReplyCell v-for="reply in replies" :key="reply.id" :reply="reply"/>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import ReplyCell from '@/components/Video/ReplyCell'

export default {
  components: {
    ReplyCell
  },
  props: {
    comment: Object
    // userName: String,
    // userId: Number,
    // id: Number,
    // message: String,
    // created_datetime: String
  },
  data () {
    return {
      courseId: this.$parent.courseId,
      weekId: this.$parent.weekId,
      activityId: this.$parent.id,
      videoId: this.$parent.videoId,
      id: this.comment.id,

      isShowReplyTextDiv: false,
      replyMessage: '',
      replies: [],
      isShowReply: false
    }
  },
  methods: {
    post_reply: function () {
      let fd = new FormData()
      fd.append('message', this.replyMessage)
      this.$store.dispatch('request', {
        method: 'post',
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.activityId}/videos/${this.videoId}/comments/${this.id}/replies`,
        data: fd
      }).then(reply => {
        console.log(reply)
        this.replies.push(reply)
        this.replyMessage = ''
      })
    },
    cancel_reply: function () {
      this.isShowReplyTextDiv = false
      this.replyMessage = ''
    }
  },
  mounted: function () {
    this.$store.dispatch('request', {
      route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.activityId}/videos/${this.videoId}/comments/${this.id}/replies`
    }).then(replies => {
      this.replies = replies
    })
  }
}
</script>
